import Helper from './Helper';

class KeyfigureAnimation {
  constructor(config = {}) {
    const {
      keyfigureSelector
    } = config;
    this.keyfigureSelector = keyfigureSelector;

    this.keyfigures = Array.prototype.slice.call(document.querySelectorAll(this.keyfigureSelector));

    if (this.keyfigures && this.keyfigures.length !== 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.keyfigures.forEach(el => {
      if ( Helper.isInViewport(el) ) {
        Helper.addClass(el, 'animate');
      }
    });

    window.addEventListener("scroll", (e) => {
      this.keyfigures.forEach((el) => {
        if ( Helper.isInViewport(el) ) {
          Helper.addClass(el, 'animate');
        }
      });
    });
  }
} export default KeyfigureAnimation;
